"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BROADCAST_SET_SELECTED_SCENE = void 0;
var BROADCAST_SET_SELECTED_SCENE = exports.BROADCAST_SET_SELECTED_SCENE = 'BROADCAST_SET_SELECTED_SCENE';